/**
 * Ponto unico de decisao do texto de reforco positivo exibido apos a
 * confirmacao de um aporte na tela "onde aportar".
 *
 * A regra de negocio da sequencia (quantos meses civis consecutivos tem
 * aporte, grace period de 1 mes, aporte retroativo que nao infla o mes
 * corrente) vive no backend, em global_functions/helpers/sequencia_aportes.py
 * — que ja devolve `titulo` e `mensagem` prontos em GET /api/sequencia_aportes/.
 * O front NAO recalcula a frase a partir de `meses_consecutivos`: duplicar a
 * escolha em dois lugares faria os textos divergirem com o tempo.
 *
 * Sobra para ca uma unica decisao: usar o texto do backend quando ele veio, ou
 * cair no texto generico quando a resposta falhou/veio incompleta. A tela de
 * reforco positivo nunca pode quebrar por causa disso — o aporte ja foi
 * registrado com sucesso quando esta mensagem aparece.
 */

export const TITULO_PADRAO = "Aporte registrado";
export const MENSAGEM_GENERICA =
	"Você está um passo mais perto do plano que desenhou";

const textoUtil = (valor) =>
	typeof valor === "string" && valor.trim() !== "" ? valor.trim() : null;

/**
 * Resolve { titulo, mensagem } a partir da resposta de GET /api/sequencia_aportes/.
 *
 * @param {object|null|undefined} dados Payload do endpoint, ou null/undefined
 *   quando a requisicao falhou.
 * @returns {{ titulo: string, mensagem: string }} Sempre preenchido, nunca lanca.
 */
export function resolverMensagemSequencia(dados) {
	const payload = dados && typeof dados === "object" ? dados : {};

	return {
		titulo: textoUtil(payload.titulo) || TITULO_PADRAO,
		mensagem: textoUtil(payload.mensagem) || MENSAGEM_GENERICA,
	};
}
